import { h, Component } from "preact";
import { Link } from "preact-router/match";
import queryString from "query-string";
import { connect } from "react-redux";
import { getUserEvents } from "../../state/actions/eventActions";
import { parseQueryString } from "../../utils/Format";
import config from "../../config";

/**
 * Display event listings (Used only for widget)
 *
 * @class EventListings
 * @extends {Component}
 */
class EventListings extends Component {
  componentDidMount() {
    const { event, getUserEvents } = this.props;
    const params = parseQueryString(location.search.replace("?", ""));
    const userId = params.u;
    const organiserId = params.o;
    if (!event.data && !event.loading) {
      getUserEvents(userId, organiserId);
    }
  }
  render() {
    let params = {};
    if (typeof window !== "undefined") {
      params = parseQueryString(location.search.replace("?", ""));
    }
    const { bc = "#6621c0", bt = "Get Tickets", tc = "#fff" } = params;
    const events = this.props.event.data || [];
    const styles = {
      container: {
        width: "100%",
        background: "#fff",
        margin: 0
      },
      row: {
        width: "99%",
        maxWidth: 800,
        margin: "10px auto 8px",
        height: 132,
        padding: "16px 20px",
        display: "flex",
        background: "#FFFFFF",
        boxShadow: "0 1px 8px 0 rgba(32, 7, 64, 0.13)",
        borderRadius: 4
      },
      leftColumn: {
        marginRight: 10
      },
      column: {
        marginRight: 10,
        whiteSpace: "nowrap",
        overflow: "hidden"
      },
      btnColumn: {
        paddingTop: 65,
        marginLeft: "auto"
      },
      img: {
        width: 200,
        height: 100
      },
      title: {
        fontSize: 18,
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis"
      },
      contents: {
        fontSize: 14,
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis"
      },
      price: {
        fontSize: 14,
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
        color: "#5A626C"
      },
      button: {
        background: bc,
        color: tc,
        minWidth: 129,
        width: "100%",
        height: 36,
        borderRadius: 4,
        paddingTop: 7,
        fontSize: 16,
        textAlign: "center"
      },
      link: {
        color: "inherit",
        textDecoration: "none"
      }
    };
    const columns = events.map(event => {
      let url =
        "https://process.filestackapi.com/resize=h:100,w:200,fit:crop/VbieTVjAQvq5BTkE9vIi";
      if (event.featureImage) {
        url = event.featureImage.url;
      }
      if (event.bannerImage) {
        url = event.bannerImage.url;
      }
      const location = !event.location
        ? ""
        : event.location.type === "online"
        ? "Online"
        : event.location.address;
      const ticketslink = `${config("TICKETING_URL")}/${event.slug}`;
      const validDates = event.dates.filter(date => {
        return !date.deleted && !date.disabled;
      });

      return (
        <a style={styles.link} href={ticketslink} target="_top">
          <div style={styles.row}>
            <div style={styles.leftColumn}>
              <img src={url} style={styles.img} alt={event.name} />
            </div>
            <div style={styles.column}>
              <div style={styles.title}>{event.name}</div>
              <div style={styles.contents}>
                {validDates[0].display.date} {validDates[0].display.time}
              </div>
              <div style={styles.contents}>{location}</div>
              <div style={styles.price}>{event.ticketsPriceStr}</div>
            </div>
            <div style={styles.btnColumn}>
              <div style={styles.button}>{bt}</div>
            </div>
          </div>
        </a>
      );
    });

    return <div style={styles.container}>{columns}</div>;
  }
}

export default connect(
  (state, ownProps) => ({
    event: state.event
  }),
  {
    getUserEvents
  }
)(EventListings);



// WEBPACK FOOTER //
// ./routes/widgets/EventListings.js